export default __webpack_public_path__ + "static/media/16.9766ef55.png";